// src/utils/filterHelpers.js

export function valueMatchesFilter(val, type, textFilter) {
  if (type === 'date') {
  const filterDate = textFilter?.value ? new Date(textFilter.value) : null;
  const rowDate = val ? new Date(val) : null;
  if (!filterDate || !rowDate) return true;
  switch (textFilter?.type) {
    case 'Equals': return rowDate.toDateString() === filterDate.toDateString();
    case 'Before': return rowDate < filterDate;
    case 'After': return rowDate > filterDate;
    default: return true;
  }
}

  if (type === 'number') {
    console.log('Number filter:', val, textFilter);
    
    const num = Number(val);
    const { type: filterType, value: filterValue } = textFilter || {};
    if (!filterType || filterType === 'Equals') return filterValue === '' || num === Number(filterValue);
    if (filterType === 'Greater Than') return filterValue === '' || num > Number(filterValue);
    if (filterType === 'Less Than') return filterValue === '' || num < Number(filterValue);
    if (filterType === 'Between') {
      const min = Number(filterValue?.min ?? '');
      const max = Number(filterValue?.max ?? '');
      if (!filterValue?.min && !filterValue?.max) return true;
      if (filterValue?.min && filterValue?.max) return num >= min && num <= max;
      if (filterValue?.min) return num >= min;
      if (filterValue?.max) return num <= max;
      return true;
    }
    return true;
  }
  if (type === 'text' || type === 'string') {
    const str = val?.toString().toLowerCase();
    const query = (textFilter?.value || '').toLowerCase();
    switch (textFilter?.type) {
      case 'Equals': return str === query;
      case 'Does Not Equal': return str !== query;	
      case 'Contains': return str?.includes(query);
      case 'Does Not Contain': return !str?.includes(query);
      case 'Begins With': return str?.startsWith(query);
      case 'Ends With': return str?.endsWith(query);
      default: return str?.includes(query); // Default to Contains
    }
  }
  // Default: string matching
  const str = val?.toString().toLowerCase();
  const query = (textFilter?.value || '').toLowerCase();
  return str?.includes(query);
}
